import { render, staticRenderFns } from "./OffCanvasMenuItem.vue?vue&type=template&id=90f2693a&"
import script from "./OffCanvasMenuItem.vue?vue&type=script&lang=js&"
export * from "./OffCanvasMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports